<section class="curation-wrapper filterPanel">
  <gen-dynamic-form class="info-dynamic-form"
                    [formName]="formName"
                    (formChange)="formChanged($event.form, $event.updated)"
                    (formInit)="formInit($event)"
                    [cancelButtonText]="'Cancel'"
                    [submitButtonText]="'Apply'"
                    [resetForm]="restForm"
                    (submitEmitter)="submit($event)"
                    (cancelEmitter)="cancel($event)">
  </gen-dynamic-form>
</section>
